import { createContext } from 'react'; //3K (gzipped : 1.4k)

const FirebaseContext = createContext(null)
export default FirebaseContext
